import { render, staticRenderFns } from "./FloorBox.vue?vue&type=template&id=088c0a83&scoped=true&"
import script from "./FloorBox.vue?vue&type=script&lang=js&"
export * from "./FloorBox.vue?vue&type=script&lang=js&"
import style0 from "./FloorBox.vue?vue&type=style&index=0&id=088c0a83&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088c0a83",
  null
  
)

export default component.exports